export const navigationLinks = [
  {
    name: 'Strona główna',
    expanded: false,
    url: '/',
    /**
    * isInnerMenu means that menu link should
    * scroll to specific (section / place) in view
    */
    isInnerMenu: false,
    submenu: null
  },
  {
    name: 'O nas',
    expanded: false,
    url: '/o-nas',
    isInnerMenu: true,
    submenu: [
      {
        name: 'Kim jesteśmy',
        url: '#ref0'
      },
      {
        name: 'Nasza kadra',
        url: '#ref1'
      },
      {
        name: 'Dlaczego z nami?',
        url: '#ref2'
      },
      {
        name: 'Nasz sprzęt',
        url: '#ref3'
      },
      {
        name: 'Nasze ośrodki',
        url: '#ref4'
      }
    ]
  },
  {
    name: 'Obozy',
    expanded: false,
    url: '/obozy',
    isInnerMenu: false,
    submenu: []
  },
  // {
  //     name: 'Konfigurator',
  //     expanded: false,
  //     url: '/konfigurator',
  //     isInnerMenu: false,
  //     submenu: [
  //         {
  //             name: 'Test',
  //             url: '/Test'
  //         }
  //     ]
  // },
  {
    name: 'Dla rodziców',
    expanded: false,
    url: '/dla-rodzicow',
    isInnerMenu: true,
    submenu: [
      {
        name: 'Bezpieczeństwo',
        url: '#ref0'
      },
      {
        name: 'Rezerwacja - krok po kroku',
        url: '#ref1'
      },
      {
        name: 'Dokumenty',
        url: '#ref2'
      },
      {
        name: 'Zgłoszenie do KO',
        url: '#ref3'
      },
      {
        name: 'Płatności',
        url: '#ref4'
      },
      {
        name: 'Dojazd',
        url: '#ref5'
      },
      {
        name: 'Faktura',
        url: '#ref6'
      },
      {
        name: 'Dofinansowanie',
        url: '#ref7'
      }
    ]
  },
  {
    name: 'Rabaty',
    expanded: false,
    url: '/rabaty',
    isInnerMenu: false,
  },
  {
    name: 'Media',
    expanded: false,
    url: '/media',
    isInnerMenu: false,
    submenu: [
      {
        name: 'Galeria',
        url: '/media/galeria'
      },
      {
        name: 'Videoteka',
        url: '/media/videoteka'
      }
    ]
  },
  {
    name: 'Opinie',
    expanded: false,
    url: '/opinie',
    isInnerMenu: false,
  },
  {
    name: 'Blog',
    expanded: false,
    url: '/blog',
    isInnerMenu: false,
  },
  {
    name: 'Kontakt',
    expanded: false,
    url: '/kontakt',
    isInnerMenu: false,
  },
]
